import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Container, Header, Table, Label, Pagination } from "semantic-ui-react";
import { fetchPastBookings } from "../../reducers/booking";
import { withTranslation } from "react-i18next";
import { format } from "date-fns";
import { TZDate } from "@date-fns/tz";
import parseTimezone from "../../lib/helperServices";

function PastExams({ bookings, kc, t, fetchPastBookings }) {
  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    fetchPastBookings(kc.tokenParsed.sub);
  }, [kc.tokenParsed.sub]);

  let timezone = parseTimezone(
    kc.tokenParsed.timezone,
    kc.tokenParsed.province
  );
  const dateFormat =
    localStorage.getItem("lang") === "en"
      ? "MMMM do yyyy - h:mm a"
      : "MMMM do yyyy - HH:mm";
  const getStatusLabel = (status) => {
    switch (status) {
      case "completed":
        return <Label color="green">{t("ExamBlock.examCompleted", "Completed")}</Label>;
      case "approved":
        return <Label color="yellow">{t("ExamBlock.notPresentForExam", "Missed")}</Label>;
      case "pending":
        return <Label color="yellow">{t("ExamBlock.notPresentForExam", "Missed")}</Label>;
      case "rejected":
        return <Label color="red">{t("ExamBlock.bookingRejected", "Rejected")}</Label>;
      case "banned":
        return <Label color="red">Banned</Label>;
      case "cancelled":
        return <Label color="grey">{t("PastExams.cancelled", "Cancelled")}</Label>;
      default:
        return <Label>{status}</Label>;
    }
  };

  const userPastBookings = bookings
    .filter((data) => data.user_id === kc.tokenParsed.sub)
    .sort((a, b) => new Date(b.booking_date) - new Date(a.booking_date));

  // Pagination logic
  const totalPages = Math.ceil(userPastBookings.length / itemsPerPage);
  const startIndex = (activePage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedBookings = userPastBookings.slice(startIndex, endIndex);

  const handlePageChange = (e, { activePage }) => {
    setActivePage(activePage);
  };

  return (
    <div>
      <Container style={{ marginTop: "1em", marginBottom: "3em" }}>
        <Header as="h2" textAlign="left" style={{ marginBottom: "1em" }}>
          {t("PastExams.header")}
        </Header>

        {userPastBookings.length > 0 ? (
          <>
            <Table striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t("PastExams.examTitle", "Exam Title")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("PastExams.date", "Date & Time")}</Table.HeaderCell>
                  <Table.HeaderCell>{t("PastExams.status", "Status")}</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {paginatedBookings.map((data, i) => (
                  <Table.Row key={`${i}_past_exam`}>
                    <Table.Cell>{data.exam?.title || "N/A"}</Table.Cell>
                    <Table.Cell>
                      {format(
                        new TZDate(data.booking_date, timezone),
                        dateFormat
                      )}
                    </Table.Cell>
                    <Table.Cell>{getStatusLabel(data.approved)}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>

            {totalPages > 1 && (
              <div style={{ textAlign: "center", marginTop: "2em" }}>
                <Pagination
                  activePage={activePage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  firstItem={null}
                  lastItem={null}
                  siblingRange={1}
                />
              </div>
            )}
          </>
        ) : (
          <div style={{ textAlign: "center", padding: "3em" }}>
            <p style={{ color: "#999" }}>{t("PastExams.noExams", "No past exams to display")}</p>
          </div>
        )}
      </Container>
    </div>
  );
}

export default withTranslation()(
  connect(
    (state) => ({
      bookings: state.bookings.pastBookings,
      kc: state.keycloak,
    }),
    { fetchPastBookings }
  )(PastExams)
);
